module.exports = __webpack_public_path__ + "img/logo-white.f27db77b.svg";